import { EavAttributeValueTypeEnum } from '@zaoblako/shared/modules/eav/enums/eav-attribute-value-type.enum';

/** EAV attribute types managed only in admin HelpDesk, hidden from personal account */
export const EAV_ATTRIBUTE_TYPES_EXCLUDED_IN_PERSONAL_ACCOUNT: readonly EavAttributeValueTypeEnum[] = [
  EavAttributeValueTypeEnum.FILIAL,
  EavAttributeValueTypeEnum.COST_CENTER,
  EavAttributeValueTypeEnum.ROOM,
  EavAttributeValueTypeEnum.COMPUTED,
];
